<template>
    <!-- 分页数据 -->
    <van-list
        v-model="pageData.loading"
        :finished="pageData.finished"
        finished-text="没有更多了"
        @load="loadTopicPageData('items-movies')"
        style="width: 100%"
    >
        <van-row>
            <van-col span="24"
                     v-for="(item,index) in list" :key="index">
                <router-link class="movie-item"
                             :to="{name:'ResourceVideo', params:{id:item.id}}"
                >
                    <van-image :src="item.cover"
                               width="30vw"
                               height="20vw"
                               radius="5px"
                               class="cover"
                    />
                    <div class="info-wrap">
                        <div class="title">{{item.title}}</div>
                    </div>
                </router-link>
            </van-col>
        </van-row>
    </van-list>
</template>

<script>
import TopicPageList from "@/views/topics/TopicPageList";
import {ellipsisString} from "@/utils/stringUtils";

export default{
    name:'Movies',
    setup(){
        // 初始化栏目分页数据
        const obj = new TopicPageList('items-movies')
        // 绑定函数，不能直接return对象的函数，会导致this不正确
        const loadTopicPageData = (topicCode,params) => obj.loadTopicPageData(topicCode,params)
        const loadTopicData = (topicCode) => obj.loadTopicData(topicCode)
        const initTopicPageListObj = (topicCode) => obj.init(topicCode)

        return{
            // 加载指定栏目数据
            loadTopicPageData,
            // 加载栏目数据
            loadTopicData,
            // 初始化TopicPageList对象
            initTopicPageListObj,
            // 栏目信息
            topicData:obj.topicData,
            // 子栏目信息
            childTopics:obj.childTopics,
            // 各栏目分页数据
            topicsPageData:obj.topicsPageData,
        }
    },
    computed:{
        pageData(){
            return this.topicsPageData['items-movies'] || {}
        },
        list(){
            const pageData = this.pageData
            const list =  pageData.list || []
            const calc = []
            list.forEach(v => calc.push({
                ...v,
                alt:v.title,
                title:ellipsisString(v.title,13),
            }))
            return calc
        },
    }
}

</script>

<style scoped>
.movie-item{
    width: 90%;
    display: flex;
    margin: 2vw 0;
}
.cover{
    box-shadow: 0 1px 10px 2px rgba(56, 56, 56, 0.1);
}
.info-wrap{
    width: calc(100% - 30vw - 5px);
    margin-left: 5px;
}
.title{
    color: #3E3E3E;
    font-weight: bold;
}
</style>
